import React, { useState, useEffect } from "react";
import "./BuyNow.scss";
import LazyLoad from "react-lazyload";
import { FormattedMessage } from "react-intl";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import "swiper/scss";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Tick = () => (
  <svg
    width="42"
    height="34"
    viewBox="0 0 42 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.5141 0.850586L14.2435 22.1212L5.84031 13.718L0.0631104 19.5827L14.2435 33.7631L41.2913 6.71532L35.5141 0.850586Z"
      fill="#76BA1B"
    />
  </svg>
);

function BuyNow({ currentLocale }) {
  const [buyNowIndex, setBuyNowIndex] = useState(0);
// number of imgs in /images/buy-now
  const num = 7;

  useEffect(() => {
    if (window.innerWidth <= 650) return;
    const intervalId = setInterval(() => {
      if (buyNowIndex === num - 1) {
        setBuyNowIndex(0);
      } else {
        setBuyNowIndex((prevIndex) => prevIndex + 1);
      }
    }, 3000);
    return () => clearInterval(intervalId); // Very important to clear interval
  }, [buyNowIndex]);

  return (
    <section id="buy-now">
      <h2>
        <FormattedMessage id="home.buy.h" />
      </h2>
      <div className="wrapper">
        <LazyLoad className="left" offset={800} once>
          <div className="images-wrapper">
            <img
              className={`${buyNowIndex === 0 ? "active" : ""}`}
              src={`images/buy-now-${currentLocale}/img1.png`}
              alt=""
            />
            <img
              className={`${buyNowIndex === 1 ? "active" : ""}`}
              src={`images/buy-now-${currentLocale}/img2.png`}
              alt=""
            />
            <img
              className={`${buyNowIndex === 2 ? "active" : ""}`}
              src={`images/buy-now-${currentLocale}/img3.png`}
              alt=""
            />
            <img
              className={`${buyNowIndex === 3 ? "active" : ""}`}
              src={`images/buy-now-${currentLocale}/img4.png`}
              alt=""
            />
            <img
              className={`${buyNowIndex === 4 ? "active" : ""}`}
              src={`images/buy-now-${currentLocale}/img5.png`}
              alt=""
            />
            <img
              className={`${buyNowIndex === 5 ? "active" : ""}`}
              src={`images/buy-now-${currentLocale}/img6.png`}
              alt=""
            />
            <img
              className={`${buyNowIndex === 6 ? "active" : ""}`}
              src={`images/buy-now-${currentLocale}/img7.png`}
              alt=""
            />
          </div>
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            modules={[Pagination, Navigation]}
            className="mySwiper swiper"
          >
            <SwiperSlide>
              <img src={`images/buy-now-${currentLocale}/img1.png`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`images/buy-now-${currentLocale}/img2.png`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`images/buy-now-${currentLocale}/img3.png`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`images/buy-now-${currentLocale}/img4.png`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`images/buy-now-${currentLocale}/img5.png`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`images/buy-now-${currentLocale}/img6.png`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`images/buy-now-${currentLocale}/img7.png`} alt="" />
            </SwiperSlide>
          </Swiper>
          <div className="points">
            <div onClick={() => setBuyNowIndex(0)} className={`point ${buyNowIndex === 0 ? "active" : ""}`}></div>
            <div onClick={() => setBuyNowIndex(1)} className={`point ${buyNowIndex === 1 ? "active" : ""}`}></div>
            <div onClick={() => setBuyNowIndex(2)} className={`point ${buyNowIndex === 2 ? "active" : ""}`}></div>
            <div onClick={() => setBuyNowIndex(3)} className={`point ${buyNowIndex === 3 ? "active" : ""}`}></div>
            <div onClick={() => setBuyNowIndex(4)} className={`point ${buyNowIndex === 4 ? "active" : ""}`}></div>
            <div onClick={() => setBuyNowIndex(5)} className={`point ${buyNowIndex === 5 ? "active" : ""}`}></div>
            <div onClick={() => setBuyNowIndex(6)} className={`point ${buyNowIndex === 6 ? "active" : ""}`}></div>
          </div>
        </LazyLoad>
        <div className="right">
          <div>
            <Tick />
            <FormattedMessage id="home.buy.point1" />
          </div>
          <div>
            <Tick />
            <FormattedMessage id="home.buy.point2" />
          </div>
          <div>
            <Tick />
            <FormattedMessage id="home.buy.point3" />
          </div>
          <div>
            <Tick />
            <FormattedMessage id="home.buy.point4" />
          </div>
          <div>
            <Tick />
            <FormattedMessage id="home.buy.point5" />
          </div>
          <div>
            <Tick />
            <FormattedMessage id="home.buy.point6" />
          </div>
          <div>
            <svg
              width="31"
              height="32"
              viewBox="0 0 31 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_5155:26621)">
                <path
                  d="M15.5 31.169C24.0605 31.169 31.0001 24.2294 31.0001 15.669C31.0001 7.10855 24.0605 0.168945 15.5 0.168945C6.9396 0.168945 0 7.10855 0 15.669C0 24.2294 6.9396 31.169 15.5 31.169Z"
                  fill="#FFC10E"
                />
                <path
                  d="M11.9134 7.36182C10.989 7.36182 10.1302 7.81262 9.61398 8.56746L9.50749 8.70279L9.43626 8.612C8.92593 7.82957 8.06565 7.36208 7.13172 7.36208C5.53813 7.36208 4.38174 8.5188 4.38174 10.1119C4.38174 12.4642 8.64041 15.9313 8.95098 16.1809C9.09757 16.3211 9.28948 16.3983 9.4931 16.3983C9.69673 16.3983 9.88864 16.3214 10.0352 16.1807C10.3468 15.9291 14.6632 12.4076 14.6632 10.1119C14.6632 8.51853 13.5067 7.36182 11.9134 7.36182Z"
                  fill="#ED3533"
                />
                <path
                  d="M23.9854 7.36182C23.061 7.36182 22.2022 7.81262 21.686 8.56746L21.5795 8.70279L21.5083 8.612C20.9979 7.82957 20.1377 7.36208 19.2037 7.36208C17.6101 7.36208 16.4537 8.5188 16.4537 10.1119C16.4537 12.4642 20.7124 15.9313 21.023 16.1809C21.1696 16.3211 21.3615 16.3983 21.5651 16.3983C21.7685 16.3983 21.9604 16.3214 22.1072 16.1807C22.4186 15.9293 26.7349 12.4076 26.7349 10.1119C26.7352 8.51853 25.5787 7.36182 23.9854 7.36182Z"
                  fill="#ED3533"
                />
                <path
                  d="M22.4523 20.8949C18.5747 24.8408 12.3358 24.8099 8.49056 20.8362C7.94112 20.2684 7.07665 21.1345 7.62538 21.7014C11.9274 26.1473 18.9835 26.171 23.3175 21.7601C23.8709 21.1972 23.006 20.3315 22.4523 20.8949Z"
                  fill="#333333"
                />
              </g>
              <defs>
                <clipPath id="clip0_5155:26621">
                  <rect
                    width="31"
                    height="31"
                    fill="white"
                    transform="translate(0 0.168945)"
                  />
                </clipPath>
              </defs>
            </svg>
            <FormattedMessage id="home.buy.point7" />
          </div>
          <a href="#presale">
            <button className="green-button">
            <FormattedMessage id="home.buy.button" /> <img alt="" src="images/icons/white-arrow.svg" />
            </button>
          </a>
        </div>
      </div>
    </section>
  );
}

export default BuyNow;
